<template>
  <div class="auth-wraper">
	  <template  v-if="$inWindow(DATE.WINTER)">
	    <snow-wrap/>
		  <christmas-login-bokeh/>
	    <christmas-lightrope/>
	  </template>

	  <!-- дефолт: показуємо лише якщо НЕ активні жодні «сезонні» вікна -->
	  <div
			  v-if="$inWindowNone([ DATE.HALLOWEEN, DATE.WINTER ])"
			  class="auth-container"
	  >
		  <div class="auth-component">
			  <div class="logoBlock">
				  <svg-sprite width="240" height="58" icon-id="logo"></svg-sprite>
			  </div>
			  <login></login>
		  </div>
	  </div>

	  <!-- halloween -->
	  <div v-if="$inWindow(DATE.HALLOWEEN)" class="halloween">
		  <halloween-auth/>
	  </div>
	  <!-- winter -->
	  <div v-if="$inWindow(DATE.WINTER)" class="auth-container winter">
		  <div class="auth-component">
			  <div class="christmas-city-wrap">
				  <svg-sprite width="382" height="110" icon-id="christmas-city"></svg-sprite>
			  </div>
			  <div class="logoBlock">
				  <svg-sprite width="240" height="58" icon-id="logo"></svg-sprite>
				  <div class="cHead">
					  <svg-sprite width="80" height="80" icon-id="cHead"></svg-sprite>
				  </div>
			  </div>
			  <login></login>
		  </div>
	  </div>
  </div>
</template>
<script>
import Login from "@/components/Auth/Login/Login";
import { DATE } from "@/constants/date";
import HalloweenAuth from "@/components/Auth/HalloweenAuth/HalloweenAuth.vue";
import SnowWrap from "@/shared/Christmas/snowWrap.vue";
import ChristmasLoginBokeh from "@/shared/Christmas/ChristmasLoginBokeh.vue";
import ChristmasLightrope from "@/shared/Christmas/ChristmasLightrope.vue";

export default {
	name: "Auth",
	components: {
		Login,
		HalloweenAuth,
		SnowWrap,
		ChristmasLoginBokeh,
		ChristmasLightrope
	},
	data: () => ({ DATE }),
	mounted() {
		this.$store.dispatch("actionPreloader", false);
	},
};
</script>
<style lang="scss" scoped>
@import "Auth";
.auth-wraper {
	height: 100%;
	width: 100%;
	position: relative;
}
</style>

<style lang="scss" scoped>
.christmas-city-wrap {
	position: absolute;
	left: 0;
	top: -109px;
	display: flex;
	align-items: center;
	width: 100%;
	justify-content: center;
}
</style>

<style lang="scss">
.auth-wraper {
	input:-webkit-autofill {
		-webkit-box-shadow: inset 0 0 0 50px var(--card-bg) !important;
		-webkit-text-fill-color: var(--card-color) !important;
		color: var(--card-color) !important;
	}
}

</style>

